<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Comentarios - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
              <b-col sm="12" md="8"></b-col>
              <b-col sm="6" md="2">
                <!-- <b-link  v-if="Permission('WebPageAdd')" class="btn form-control btn-primary" :to="{ path: '/promociones/nuevo' }" append>NUEVO</b-link> -->
              </b-col>
              <b-col sm="6" md="2">
                <b-input-group>
                  <b-form-input v-model="search" class="form-control"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="ListPromotion">
                      <b-icon icon="search"></b-icon
                    ></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="5%" class="text-center">#</th>
                    <th width="30%" class="text-center">Cliente</th>
                    <th width="25%" class="text-center">Producto</th>
                    <th width="20%" class="text-center">Comentario</th>
                    <th width="5%" class="text-center">Valoración</th>
                    <th width="5%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-left"> {{ item.name + ' - '+ item.document_number }}</td>
                    <td class="text-left"> {{ item.product_name }}</td>
                    <td class="text-left"> {{ item.commentary }}</td>
                    <td class="text-center"> {{ item.score }}</td>
                    <td class="text-center">
                      <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                      <b-badge v-if="item.state == 0" variant="danger">Anulado</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <!-- <b-dropdown-item v-if="Permission('WebPageEdit')" @click="EditPromotion(item.id_commentary)">Editar</b-dropdown-item> -->
                        <b-dropdown-item v-if="Permission('WebPageView')" @click="ViewPromotion(item.id_commentary)" >Ver</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('WebPageDelete')" @click="ConfirmDeletePromotion(item.id_commentary)">Eliminar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListPromotion" :total-rows="rows" :per-page="perPage" align="center"></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "UsuarioList",
  data() {
    return {
      module:'WebPage',
      role:1,
      perPage: 15,
      currentPage: 1,
      rows: 0,
      search: "",
      data_table: [],
    };
  },
  mounted() {
    this.ListPromotion();
  },
  methods: {
    ListPromotion,
    EditPromotion,
    ViewPromotion,
    ConfirmDeletePromotion,
    DeletePromotion,
    Permission,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

//listar usuario
function ListPromotion() {
  let search = this.search == "" ? "all" : this.search;
  let me = this;
  let url =
    this.url_base + "commentary/list/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 1,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditPromotion(id_commentary) {
  this.$router.push({
    name: "CommentaryEdit",
    params: { id_commentary: je.encrypt(parseInt(id_commentary)) },
  });
}

// Ver Usuario
function ViewPromotion(id_commentary) {
  this.$router.push({
    name: "CommentaryView",
    params: { id_commentary: je.encrypt(parseInt(id_commentary)) },
  });
}

// Confirmar eliminar
function ConfirmDeletePromotion(id_commentary) {
  Swal.fire({
    title: "Esta seguro de eliminar el comentario?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeletePromotion(id_commentary);
    }
  });
}

// eliminar usuario
function DeletePromotion(id_commentary) {
  let me = this;
  let url = this.url_base + "commentary/delete/" + id_commentary;
  axios({
    method: "delete",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 4,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        for (var i = 0; i < me.data_table.length; i++) {
          if (me.data_table[i].id_commentary == id_commentary) {
            me.data_table.splice(i, 1);
            break;
          }
        }
        Swal.fire({ icon: 'success', text: 'El comentario ha sido eliminado', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
